import React from 'react'

const OfferDetailPage = () => {
  return <h1>Offer Detail</h1>
}

export default OfferDetailPage
